// custom component (not registry-generated)
import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

export { default as Icon } from './Icon.vue'

// The icon primitive. `name` renders a glyph from the ICONS registry
// (`~ds/lib/icons`) through @nuxt/icon; without it the default slot takes an
// inline SVG. Either way it is `size`d, inherits `currentColor` and is
// decorative unless given a `label`. No baked-in default glyph: a specific mark
// (e.g. the AI sparkle) is a feature asset, not part of the generic shell.
// Hugeicons are drawn with a 1.5 stroke on a 24px grid, so at 12px and 24px the stroke lands on a
// fractional pixel (0.75px / 1.5px) and reads blurry on low-DPI screens: those two sizes round it up
// to a whole device pixel there. The off-grid `custom:` collection marks itself `data-collection`
// and is left alone by the selector, so the compensation stays a size decision, in the recipe.
const LOW_DPI_STROKE = 'lowdpi:[&:not([data-collection=custom])_*]:stroke-2'

export const iconVariants = cva('', {
  variants: {
    size: {
      'xs': `size-3 ${LOW_DPI_STROKE}`,
      'sm': 'size-4',
      'md': 'size-5',
      'lg': `size-6 ${LOW_DPI_STROKE}`,
      'xl': 'size-8',
      '2xl': 'size-10',
      '3xl': 'size-12',
    },
  },
})
export type IconVariants = VariantProps<typeof iconVariants>
